import React from 'react';
import './ListMyOrgs.css';
import {formatCompanyName} from '../../utils/formatCompanyName';
const ListMyOrgs = ({listOrgs = [], handleSelectedOrgs, selectedItemId}) => {
  return (
    <div className='list-my-org'>
      <div className='list-my-org__wrapper'>
        <h2 className='list-my-org__title'>Мои организации</h2>
        <ul className='list-my-org__list'>
          {listOrgs.map((item) => (
            <li
              onClick={() => handleSelectedOrgs(item.id)}
              key={item.id}
              className={`list-my-org_item ${
                selectedItemId === item.id ? 'selected' : ''
              }`}
            >
              {formatCompanyName(item.name)}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ListMyOrgs;
